import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LeavesDetailsComponent } from './components/leaves-details/leaves-details.component';
import { LeavesViewComponent } from './components/leaves-view/leaves-view.component';
import { LeavesStatusComponent } from './components/leaves-status/leaves-status.component';
import { DefaultComponent } from 'src/app/layouts/default/default.component';
import { AuthGuard } from 'src/app/auth/services/auth.guard';
import { Role } from 'src/app/auth/models/user';

const routes: Routes = [
   {
       path: '', component:DefaultComponent, children: [
        {
            path: '', component: LeavesDetailsComponent
        },
        {
            path: 'leaves', component: LeavesDetailsComponent
        },
        {
            path: 'view/:id', component:  LeavesViewComponent
        },
        // {
        //     path: 'leaves-status/:id', component:  LeavesStatusComponent
        // },
        {
            path: 'leaves-status-details/:id',component:LeavesStatusComponent
        },
        {   //todo route you want to add validation for
            path: 'leaves-status/:id',
            component: LeavesStatusComponent,
            canActivate: [AuthGuard],
            // data: { allowedRoles: [Role.SuperAdmin,Role.OrganizationAdmin,] } //recommend you dont use string here.
        },
       ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeavesRoutingModule { }